// extracted by mini-css-extract-plugin
export default {"content":"style_content__B1fq3","itemName":"style_itemName__2VyCg"};